import React from 'react';
import { ShieldAlert, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-navy text-white py-16 px-4" data-id="element-188">
      <div className="max-w-3xl mx-auto" data-id="element-189">
        <div className="text-center mb-12" data-id="element-190">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gold" data-id="element-191">
            Reflections of a patriot who never stopped believing in the American
            Dream.
          </h2>
          <div className="w-24 h-1 bg-patriot-red mx-auto mb-8" data-id="element-192"></div>
        </div>

        <div className="prose prose-lg prose-invert mx-auto" data-id="element-193">
          <p className="text-xl leading-relaxed mb-6 font-medium" data-id="element-194">
            The America we know is under attack, and the battlefield isn't just
            in Washington—it's in our schools, our homes, and our history books.
            For too long, the voices of traditional values have been silenced by
            a culture that wants you to forget what made this nation
            exceptional.
          </p>

          <p className="text-gray-300 mb-10" data-id="element-195">
            This isn't just an audiobook; it's a digital fortress for your
            values. It is a roadmap for the next generation of patriots who
            refuse to let the fire of liberty go out on their watch.
          </p>

          <div className="bg-navy-light p-8 rounded-xl border border-blue-900/50 mb-12 shadow-lg" data-id="element-196">
            <div className="flex items-center gap-3 mb-4" data-id="element-197">
              <ShieldAlert className="text-patriot-red" size={28} data-id="element-198" />
              <h3 className="text-2xl font-bold text-white m-0" data-id="element-199">
                The Coordinated Effort
              </h3>
            </div>
            <p className="text-gray-300 mb-4" data-id="element-200">
              You feel it every time you turn on the news or scroll through
              social media. There is a coordinated effort to rewrite our history
              and shame those who still believe in Faith, Family, and Freedom.
            </p>
            <p className="text-gray-300" data-id="element-201">
              The pressure to conform is everywhere. If you stay silent, they
              win. But speaking up feels dangerous without the right foundation.
              You want to protect your family's future, but the "modern" world
              is trying to disconnect you from the very principles that ensure
              that future.
            </p>
          </div>

          <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-202">
            Why What You Tried Didn't Work
          </h3>

          <ul className="space-y-4 mb-8" data-id="element-203">
            <li className="flex items-start gap-3 bg-navy-light/50 p-4 rounded-lg" data-id="element-204">
              <XCircle className="text-patriot-red flex-shrink-0 mt-1" size={20} data-id="element-205" />
              <span className="text-gray-300" data-id="element-206">
                Watching endless news cycles only leaves you feeling outraged
                and exhausted without a plan for action.
              </span>
            </li>
            <li className="flex items-start gap-3 bg-navy-light/50 p-4 rounded-lg" data-id="element-207">
              <XCircle className="text-patriot-red flex-shrink-0 mt-1" size={20} data-id="element-208" />
              <span className="text-gray-300" data-id="element-209">
                Arguing on social media rarely changes minds and often leads to
                more division and frustration.
              </span>
            </li>
            <li className="flex items-start gap-3 bg-navy-light/50 p-4 rounded-lg" data-id="element-210">
              <XCircle className="text-patriot-red flex-shrink-0 mt-1" size={20} data-id="element-211" />
              <span className="text-gray-300" data-id="element-212">
                Waiting for "the next election" to fix everything ignores the
                cultural rot happening in our backyard today.
              </span>
            </li>
            <li className="flex items-start gap-3 bg-navy-light/50 p-4 rounded-lg" data-id="element-213">
              <XCircle className="text-patriot-red flex-shrink-0 mt-1" size={20} data-id="element-214" />
              <span className="text-gray-300" data-id="element-215">
                Generic political books give you theories, but they don't give
                you the emotional fuel to lead your family.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}